import type { ActiveTab } from "@/appInterface/windows/VoteWindow/types";
import type { HeaderButtonNames, UserSessionData } from "@/interface/types";

export type EventMap = {
    "canvas.zoom.update": { zoom: number };
    "toolbox.switch": { toolName: string };
    "search.results.update": { total: number; currentIndex: number };
    // TODO: board info type
    "board.info": Record<string, any>;
    "multi.cursors": { disableMultiCursors: boolean };
    "header.visibility": { name: string | null };
    "button.disabled": Record<string, boolean>;
    "multi.users.sessions": { users: UserSessionData[] };
    "multi.users.trackingSession": { session: string | null };
    "vote.timer.visibility": { isVisible: boolean };
    "header.button.active.name": { name: HeaderButtonNames | null };
    "vote.start.visibility": { isVisible: boolean };
    "vote.start.activeTab": { tab: ActiveTab };
    "vote.active.visibility": { isVisible: boolean };
};

export type EventMapKey = keyof EventMap;
export type EventData<T extends EventMapKey> = EventMap[T];
export type EventHandler<T extends EventMapKey> = (data: EventData<T>) => void;

class EventEmitter {
    private handlers: {
        [K in EventMapKey]?: Set<EventHandler<K>>;
    } = {};

    on<T extends EventMapKey>(event: T, handler: EventHandler<T>): void {
        if (!this.handlers[event]) {
            this.handlers[event] = new Set<EventHandler<EventMapKey>>();
        }
        this.handlers[event].add(handler);
    }

    off<T extends EventMapKey>(event: T, handler: EventHandler<T>): void {
        const eventHandlers = this.handlers[event] as Set<EventHandler<T>>;
        if (eventHandlers) {
            eventHandlers.delete(handler);
        }
    }

    dispatch<T extends EventMapKey>(event: T, data: EventData<T>): void {
        const eventHandlers = this.handlers[event] as Set<EventHandler<T>>;
        //todo удалить после переноса на реакт
        if (localStorage.getItem("debug")) {
            console.log(`[${event}]: ${eventHandlers?.size || 0} handlers`);
        }
        if (eventHandlers) {
            eventHandlers.forEach((handler) => {
                try {
                    handler(data);
                } catch (error) {
                    console.error(`Error in event handler for ${event}:`, error);
                }
            });
        }
    }
}

export default new EventEmitter();
